<template>
  <div
    v-click-outside="hide"
    class="c-select"
    :class="[classes ? classes : '', {'is-error': isError && errorMessage && errorMessage != ''}]"
    @click="toggle"
  >
    <div v-if="title" class="c-select__title">
      {{ title }}
    </div>
    <div class="c-select__selected" :class="{ 'is-empty': !currentText }">
      {{ currentText ? currentText : placeHolder }}
    </div>
    <div class="c-select-options" :class="{ 'is-active': opened }">
      <div
        v-if="hasBlank"
        class="c-select-options__item"
        :data-value="null"
        @click="onItemClick(null,'')"
      >
        {{ blankText }}
      </div>
      <div
        v-for="(text,optionValue) in elements"
        :key="'select-text-' + String(optionValue)"
        class="c-select-options__item"
        :data-value="optionValue"
        @click="onItemClick(optionValue,text)"
      >
        {{ text }}
      </div>
      <!-- <template v-if="Array.isArray(this.elements)">
            <div
                v-for="(text,value) in elements"
                class="c-select-options__item"
                :data-value="value"
                v-on:click="onItemClick(value,text)"
            >
                {{ text }}
            </div>
        </template>
        <template v-else>
            <div
                v-for="(text,value) in elements"
                class="c-select-options__item"
                :data-value="value"
                v-on:click="onItemClick(value,text)"
            >
                {{ text }}
            </div>
        </template> -->
    </div>
    <input type="hidden" :name="inputName" value="" />
    <div
      class="c-error c-error--balloon c-error--group-name"
      :class="[{'vc-zf35gktmw6': classes.indexOf('vc-zf35gktmw6') > -1, 'is-active': isError && errorMessage && errorMessage != ''}]"
    >
      <div class="c-error__text">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
import ClickOutside from '../../directives/click-outside'

export default {
  directives: {
    ClickOutside
  },
  props: {
    classes: Array,
    elements: [Object, Array],
    placeHolder: String,
    title: String,
    value: String,
    index: { type: Number, required: false },
    inputName: {
      type: String,
      default: 'segment_condition_id',
    },
    hasBlank: {
      type: Boolean,
      default: false,
    },
    blankText: { type: String, required: false },
    isError: { type: Boolean, required: false },
    errorMessage: { type: String, required: false },
  },
  emits: ["select"],
  data() {
    return {
      opened: false,
      //currentText: null,
      currentValue: this.value,
    }
  },
  computed: {
    currentText: function () {
      return this.elements[this.currentValue];
    }
  },
  watch: {
    value: function(newValue, _oldValue){
      this.currentValue = newValue;
    }
  },
  mounted: function () {
    if(this.value){
      this.setValue(this.value);
    }
  },
  methods: {
    toggle: function () {
      if (this.opened) {
        this.hide();
      } else {
        this.show();
      }
    },
    show: function () {
      this.opened = true;
    },
    hide: function () {
      this.opened = false;
    },
    onItemClick: function (value, _text) {
      this.currentValue = value;
      this.$emit("select", this.currentValue, this.index);
    },
    setValue: function(value) {
      let text = this.elements[value];
      if(text){
        this.currentValue = value;
      }
    },
    clearValue: function() {
      this.currentValue = null;
    },
  },
}
</script>
